export default [
  {
    title: "Recomandări oficiale",
    doc_type: "USEFUL_APP",
    doc_id: 1,
    active: true,
    display_order: 1,
    app_type: "INFO",
    content: "15 RECOMANDĂRI privind conduita socială responsabilă în prevenirea răspândirii coronavirus",
    buttons: [
      {
        title: "Citește aici",
        link: "https://stirioficiale.ro/15-recomandari-privind-conduita-sociala-responsabila-in-prevenirea-raspandirii-coronavirus"
      }
    ]
  }
  ,
  {
    title: "Instalează-ți extensia de Chrome pentru a depista știrile false",
    doc_type: "USEFUL_APP",
    doc_id: 2,
    active: true,
    display_order: 2,
    app_type: "NEWS",
    content: null,
    buttons: [
      {
        title: "Instalează extensie",
        link: "https://chrome.google.com/webstore/detail/covid-19-stiri-oficiale/pdcpkplohipjhdfdchpmgekifmcdbnha"
      }
    ]
  }
  ,
  {
    title: "Instalează-ți extensia de Firefox pentru a depista știrile false",
    doc_type: "USEFUL_APP",
    doc_id: 3,
    active: true,
    display_order: 3,
    app_type: "NEWS",
    content: null,
    buttons: [
      {
        title: "Instalează extensie",
        link: "https://addons.mozilla.org/en-US/firefox/addon/covid-19-%C8%99tiri-oficiale/"
      }
    ]
  }
  ,
  {
    title: "Știri oficiale și informații la zi",
    doc_type: "USEFUL_APP",
    doc_id: 4,
    active: true,
    display_order: 4,
    app_type: "NEWS",
    content: null,
    buttons: [
      {
        title: "Cele mai noi informații oficiale",
        link: "https://stirioficiale.ro/"
      }
    ]
  },
  {
    title: "Vrei să ajuți. Intră aici",
    doc_type: "USEFUL_APP",
    doc_id: 5,
    active: true,
    display_order: 5,
    app_type: "OFFER_HELP",
    content: null,
    buttons: [
      {
        title: "Donează prin RoHelp",
        link: "https://rohelp.ro/"
      }
    ]
  },
  {
    title: "Date la zi",
    doc_type: "USEFUL_APP",
    doc_id: 6,
    active: true,
    display_order: 6,
    app_type: "DATA",
    content: null,
    buttons: [
      {
        title: "Vezi aici date la zi",
        link: "https://datelazi.ro/"
      }
    ]
  },
  {
    title: "Ești în afara țării și ai nevoie de ajutor?",
    doc_type: "USEFUL_APP",
    doc_id: 7,
    active: true,
    display_order: 7,
    app_type: "DIASPORA",
    content: null,
    buttons: [
      {
        title: "Intră pe DiasporaHub",
        link: "https://diasporahub.ro"
      }
    ]
  },
  {
    title: "Monitorizează-ți starea de sănătate",
    doc_type: "USEFUL_APP",
    doc_id: 8,
    active: true,
    display_order: 8,
    app_type: "MEDICAL",
    content: null,
    buttons: [
      {
        title: "Fă-ți cont pe Jurnal Medical",
        link: "https://jurnalmedical.ro/"
      }
    ]
  }
];
